import React from 'react'
import { Text, csx } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

import { FormattedPostalCode } from '../../../../components'

export type PostalCodeTextProps = {
  value: string
}

export const PostalCodeText = ({ value }: PostalCodeTextProps) => (
  <Text
    variant="action2"
    tone="secondary"
    className={csx({ display: 'block' })}
  >
    <FormattedMessage id="checkout.confirm-cep-step.label" />{' '}
    <FormattedPostalCode value={value} />
  </Text>
)
